import type { UserEvent } from "@/services/api/cronos/user/events/get-all"
import type { Activity } from "../entities/activities"
import type { DailyCalendarEvent } from "../entities/daily-calendar"

export default function getDailyCalendarEvents(
  events: UserEvent[],
  activities: Activity[],
): DailyCalendarEvent[] {
  const dailyCalendarEvents: DailyCalendarEvent[] = []

  events.forEach((event) => {
    dailyCalendarEvents.push({
      ...event,
      dailyCalendarEventType: "event",
    })
  })

  activities.forEach((activity) => {
    dailyCalendarEvents.push({
      ...activity,
      dailyCalendarEventType: "activity",
    })
  })

  return dailyCalendarEvents
}
